import React from 'react';
import styles from './style.css';

function TableManagementDisplay(props) {
  const { tableManagementReport } = props;
  return (
    <div>
      <div className="row">
        <div className="col-xs-12 col-sm-6 col-md-4">
          <div className={styles['table-management-box']}>
            <div className="title-left">TOTAL PAX</div>
            <div className={styles['about-box']}>
              {tableManagementReport.totalPax}
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <div className={styles['table-management-box']}>
            <div className="title-left">AVG REVENUE PER PAX</div>
            <div className={styles['about-box']}>
              {tableManagementReport.avgRevenue}
            </div>
          </div>
        </div>
        <div className="col-xs-12 col-sm-6 col-md-4">
          <div className={styles['table-management-box']}>
            <div className="title-left">AVG DINE IN TIME PER TABLE</div>
            <div className={styles['about-box']}>
              {tableManagementReport.avgTime}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TableManagementDisplay;
